// Import the necessary Firebase modules
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getDatabase } from "firebase/database";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCbO3GvvEl1uOu3EZCjAnfA5FySjQT9cFI",
  authDomain: "smstextr.firebaseapp.com",
  projectId: "smstextr",
  storageBucket: "smstextr.appspot.com",
  messagingSenderId: "70906003072",
  appId: "1:70906003072:web:e1b25ea2c9b224e3bdf065",
  measurementId: "G-YL665Y0D7E"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and set up Google Provider
export const auth = getAuth(app);

// Initialize Firebase Realtime Database
export const database = getDatabase(app);

// Initialize Google authentication provider
export const googleProvider = new GoogleAuthProvider();
